function toggleProductInfo() {
  let button = $('.product-info__button-pc');
  let container = $('.product-info__container');
  for (let i = 0; i < Array.from(button).length; i++) {
    $(button[i]).on('click', function () {
      let id = button[i].getAttribute('data-id');
      let block = $('.product-info__container[data-id="' + id + '"]');
      button.removeClass('active');
      $(this).addClass('active');
      container.removeClass('active');
      $(block).attr('data-id', $(this).attr('data-id')).addClass('active');
    });
  }
}
toggleProductInfo();

function toggleProductInfoMobile() {
  let button = $('.product-info__button-mobile');
  let container = $('.product-info__container');
  for (let i = 0; i < button.length; i++) {
    $(button[i]).on('click', function () {
      let id = button[i].getAttribute('data-id');
      let block = $('.product-info__container[data-id="' + id + '"]');

      // Проверяем, активен ли уже выбранный блок
      let isActive = $(this).hasClass('active');

      // Убираем классы active с кнопок и блоков
      button.removeClass('active');
      container.removeClass('active');

      // Если блок не активен, делаем его активным, иначе оставляем его закрытым
      if (!isActive) {
        $(this).addClass('active');
        $(block).addClass('active');
      }
    });
  }
}

toggleProductInfoMobile();
